import paper from 'paper';

export class TaggableCanvasAsset extends paper.Raster {
    public locked = true;
    public neuralaType = 'TaggableImage';
    public crossOrigin = 'anonymous';
    public sourceRaster: any;

    constructor(params: any) {
        super(params);
    }
}



// WEBPACK FOOTER //
// ./src/components/workspace/objects/taggableCanvasAsset.ts